import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import { LaIconEditorTab } from "^/Components/ScrivitoExtensions/LaIconEditorTab";
import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";
import {
  defaultPageProperties,
  defaultPageInitialContent,
} from "../_defaultPageEditingConfig";

Scrivito.provideEditingConfig("EventOverviewPage", {
  title: "Event Overview Page",
  hideInSelectionDialogs: true,
  attributes: localizeAttrList(
    [...defaultPageProperties, ...metadataPropertiesGroup.properties],
    "EventOverviewPage"
  ),
  properties: ["title", "description", "recommendedEvents", "hideInNavigation"],
  propertiesGroups: [
    {
      title: "LA Icon",
      component: ({ obj }) => (
        <LaIconEditorTab obj={obj} attribute="navigationIcon" />
      ),
      key: "laIconEditorTab",
    },
    socialCardsPropertiesGroup,
    metadataPropertiesGroup,
  ],
  initialContent: {
    ...defaultPageInitialContent,
    title: "Event Overview",
    ...metadataInitialContent,
  },
});
